//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    bestsellers: { type: Array, required: true },
    limit: { type: Number, default: 6 },
    sku: { type: String, required: true },
    currentDesign: { type: Object, default: () => {} },
    currentDesignDetails: { type: Object, default: () => {} },
    simpleMode: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    skuField: { type: String, default: 'sku' }
  },
  data () {
    return {
      previousDesign: null
    }
  },
  computed: {
    resolvedBestsellers () {
      return this.bestsellers.slice(0, this.limit).map((bestseller) => {
        bestseller.skuWithoutSwappableParts = this.$store.getters['product/skuWithoutSwappableParts'](bestseller.sku)
        return bestseller
      })
    },
    resolvedBestsellersWithCustomDesign () {
      if (this.previousDesign !== null) return [
        ...this.resolvedBestsellers.slice(0, this.limit - 1),
        this.previousDesign
      ]
      return this.resolvedBestsellers
    },
    framePart () {
      return Object.keys(this.currentDesign).find(part => part.endsWith('f'))
    },
    lensPart () {
      return Object.keys(this.currentDesign).find(part => part.endsWith('le'))
    },
    currentFrameChoice () {
      if (this.simpleMode) return null
      return this.currentDesign[this.framePart]
    },
    currentLensChoice () {
      if (this.simpleMode) return null
      return this.currentDesign[this.lensPart]
    },
    designIsBestseller () {
      return this.resolvedBestsellers.filter(
        bestseller => bestseller.frame === this.currentFrameChoice && this.normaliseSku(bestseller.lens) === this.normaliseSku(this.currentLensChoice)
      ).length > 0
    }
  },
  watch: {
    sku () {
      if (!this.designIsBestseller && !this.simpleMode) this.previousDesign = this.getBestsellerFromDesign()
    }
  },
  methods: {
    select (payload) {
      this.$emit('select', payload)
    },
    normaliseSku (sku) {
      return this.$store.getters['product/changeLensTech'](sku, this.$store.getters['product/lensTech'](this.sku))
    },
    getBestsellerFromDesign () {
      return {
        frame: this.currentFrameChoice,
        frameStyling: this.currentDesignDetails[this.framePart].styles,
        lens: this.currentLensChoice,
        lensStyling: this.currentDesignDetails[this.lensPart].styles,
        sku: this.sku,
        skuWithoutSwappableParts: this.$store.getters['product/skuWithoutSwappableParts'](this.sku),
        [this.skuField]: this.sku
      }
    },
    getSKU (bestseller) {
      if (bestseller.isLE || bestseller.isGiftCard) return this.normaliseSku(bestseller.sku)
      return this.normaliseSku(bestseller[this.skuField] || '')
    },
    isSelected (bestseller) {
      if (this.simpleMode) {
        // Get the bestseller SKU and current SKU, split by -, sort alphabetically then compare
        const bestsellerSkuSorted = this.getSKU(bestseller).split('-').sort((a, b) => a.localeCompare(b)).join('-')
        const currentSkuSorted = (this.sku || '').split('-').sort((a, b) => a.localeCompare(b)).join('-')
        return bestsellerSkuSorted === currentSkuSorted
      } else {
        return bestseller.frame === this.currentFrameChoice && this.normaliseSku(bestseller.lens) === this.normaliseSku(this.currentLensChoice)
      }
    },
    resolveURLs (string) {
      return (string || '').replace(/https*:\/\/.+?images/g, `${this.$config.staticAssetURL}/images`)
    }
  }
}
